import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-950 text-zinc-500">
        <div className="mono text-xs">checking session…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <Outlet />;
}
